import { MODULES } from '../kinds';
import { loadStudioType, studioConfig } from '../../studio/types';
import { sealedModule } from './sealed';
import { addonFor } from './addons';
import type { GameModule } from '../sdk/toolkit';

export type Resolved = { module: GameModule } | { missing: string };

async function studioModule(content: Record<string, unknown>): Promise<Resolved> {
  const typeId = typeof content.studioType === 'string' ? content.studioType : '';
  const type = typeId ? await loadStudioType(typeId) : null;
  if (!type) return { missing: 'This program uses a Studio game that is not available.' };
  const config = studioConfig(type.manifest, content);
  const thin = type.manifest.content.some((f) => {
    const v = config[f.id];
    return f.type === 'words' && Array.isArray(v) && v.length < (f.min ?? 1);
  });
  return {
    module: sealedModule({
      code: type.code,
      title: type.manifest.name,
      config,
      tag: { studioType: type.manifest.id, studioVersion: type.manifest.version },
      empty: thin ? 'Edit it to add what the learner practises.' : null,
    }),
  };
}

export async function resolveModule(kind: string, content: Record<string, unknown>): Promise<Resolved> {
  if (kind === 'studio') return studioModule(content);
  const addon = await addonFor(kind);
  if (addon) return { module: addon.module };
  const builtIn = (MODULES as Record<string, GameModule | undefined>)[kind];
  if (builtIn) return { module: builtIn };
  return { missing: 'This program uses a game that is not available.' };
}
